import React, { useEffect, useState, useContext } from "react";
import { formatDateWithYear } from "../../../utils/hooks/dataHandler";
import CaSummary from "../../../components/Schedules/CA/CASummary";
import { AuthContext } from "../../../contexts/AuthContext";
import { getCaSettings } from "../../../builders/settings/CaSetting";
import ComponentLoading from "../../../components/App/ComponentLoading";
import { useErrorDialog } from "../../../contexts/ErrorDialogContext";
import { useSuccessDialog } from "../../../contexts/SuccessDialogContext";
import { useAccessControl } from "../../../utils/hooks/useAccessControl";
import { CA_SCHEDULES } from "../../../utils/data/controlData";

const CaSummaryPage = ({
  uen,
  detailsId,
  scheduleId,
  companyName,
  yearOfAssessment,
  financialYearStart,
  financialYearEnd,
}) => {
  const {
    getCAScheduleDataByType,
    getCASummaryPDFDetails,
    deleteCAScheduleByType,
  } = useContext(AuthContext);
  const [schedule, setSchedule] = useState({});
  const [scheduleDetails, setScheduleDetails] = useState({});

  const { canEdit: canEditCASchedule } = useAccessControl(CA_SCHEDULES);

  const [loading, setLoading] = useState(true);

  const handleError = useErrorDialog();
  const handleSuccess = useSuccessDialog();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        // Fetch schedule data from API
        const response = await getCAScheduleDataByType(scheduleId, 'CASummary');
        const result = await getCASummaryPDFDetails(detailsId);
        const scheduleData = response?.schedule;

        let caSettings = getCaSettings();

        if (scheduleData) {
          setSchedule({
            id: scheduleId,
            type: "CA Summary",
            scheduleNo: scheduleData.scheduleNo,
            name: "CA Summary",
            caSettings: scheduleData.caSetting || caSettings,
            notes: scheduleData.notes || "",
            reviewNotes: scheduleData.reviewNotes || "",
          });

          setScheduleDetails({
            summary: result,
          });
        }
      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    };

    if (uen && scheduleId) {
      fetchData();
    }
  }, [scheduleId, uen]);

  const deleteSchedule = async () => {
    if (!scheduleId) {
      handleError("Missing Schedule ID.");
      return;
    }

    const updatedSchedule = {
      sch_id: scheduleId,
    };

    setLoading(true);
    const response = await deleteCAScheduleByType(updatedSchedule);
    setLoading(false);

    if (response) {
      handleSuccess("Schedule deleted successfully.");
      localStorage.removeItem("selectedSection");
      localStorage.setItem("selectedComponent", "Detailed P&L");
      window.location.reload();
    } else {
      handleError(
        "There was a problem saving the schedule. Please contact support if the issue persists."
      );
    }
  };

  return (
    <>
      {loading ? (
        <ComponentLoading />
      ) : (
        <CaSummary
          companyName={companyName}
          uen={uen}
          yearOfAssessment={yearOfAssessment}
          financialYearStart={formatDateWithYear(financialYearStart)}
          financialYearEnd={formatDateWithYear(financialYearEnd)}
          schedule={schedule}
          scheduleDetails={scheduleDetails}
          deleteSchedule={deleteSchedule}
          canEdit={canEditCASchedule}
        />
      )}
    </>
  );
};

export default CaSummaryPage;
